
import Card from '@/components/card/card.vue'
import{ref,inject,reactive,onUpdated,nextTick,onMounted,onBeforeUnmount} from 'vue'
import Headline from '@/components/headline/headline.vue'
import popularCard from '@/components/card/popular-card.vue'
interface Hotcategory {
  list:Array<Object>
}
export default {
 components:{
       Headline,
       Card,
       popularCard
    },
  setup(){
      const refCross:any = ref(null)
      const headerMenu:any=ref(null)
      const refClsDiv:any=ref(null)
       const $http: any = inject('$http')
       
      let hotcategory:Hotcategory = reactive({
        list:[]
      })    
      //移动的距离
      let barMoveWidth = ref(0)
      //父盒子的总宽度
      let widthList = ref(0)      
      const get_hotcategory_fns = (async ()=>{       
        const res = await $http.get_hotcategory()
        if(res.code === 200){
          hotcategory.list = res.data             
          nextTick(()=>{
            let itemWieth = refCross.value && refCross.value.length > 0 ? refCross.value[0].clientWidth : 80
            widthList.value =  Math.ceil(hotcategory.list.length/2) * itemWieth + 7    
            refClsDiv.value.style.setProperty('--max_width', widthList.value + 'px')                                                    
          })   
        }        
      })
      const handleScroll = ()=>{
         nextTick(()=>{
           setTimeout(() => {
             if(headerMenu.value){
                                 //拿到被滚动卷出去的距离
           const scroll = headerMenu.value.scrollLeft                    
           //拿到每个元素的宽度
           const clinet = refCross.value && refCross.value.length > 0 ? refCross.value[0].clientWidth : 80
           if(scroll>=clinet){
               let str = 50 / Math.ceil(hotcategory.list.length/2)
               barMoveWidth.value = str * Math.ceil(scroll/clinet)
               if((headerMenu.value.clientWidth +scroll) >= widthList.value  ){
                      barMoveWidth.value = 50                                             
               }                         
           } else{
               barMoveWidth.value = 0
           } 
             }

           }, 0);
                  
         })  
      }       
      onMounted( async()=>{       
        get_hotcategory_fns()                 
          window.addEventListener('scroll', handleScroll, true);                          
      });
      onBeforeUnmount(()=>{
         window.removeEventListener('scroll', handleScroll, true)
       
      })
     
      return {
        hotcategory,     
        barMoveWidth,
        refCross,
        headerMenu,
        refClsDiv
      } 
  },
}
